export default function PlusIcon() {
    return (
        <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M11.3594 19H8.0625V11.3125H0.34375V8.0625H8.0625V0.34375H11.3594V8.0625H19V11.3125H11.3594V19Z" fill="#62DED7" />
        </svg>
    )
}
